module.exports = __webpack_public_path__ + "static/media/country_cy.b33e4f79.webp";